import { MenuAction } from '@ordr-as/umami-react/context-menu';
import { FormattedMessage } from 'react-intl';
import ExternallinkIcon from '@ordr-as/icons/ExternallinkIcon';

const TERMS_URL = 'https://static.favrit.com/User+terms+-+platform+user/User+terms+-+platform+user.pdf';

const TermsAndConditions = () => (
  <MenuAction className="border-b border-grey-lightest !py-3" onClick={() => window.open(TERMS_URL, '_blank')}>
    <div className="flex w-full items-center justify-between text-base text-brand-black">
      <FormattedMessage id="header.termsAndConditions" />
      <ExternallinkIcon width={20} height={20} />
    </div>
  </MenuAction>
);
export default TermsAndConditions;
